import React from "react";
import { t } from "ttag";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (props: templates.ExamplePageTemplate) => (
    <React.StrictMode>
        <PageSkeleton {...props.page}>
            <h1>{t`Hello World!`}</h1>
        </PageSkeleton>
    </React.StrictMode>
);
